import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../betradar';
export function fetchBetradarStreamUrl(radarId) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_BETRADAR_STREAM
            },
            _a[CALL_API] = {
                endpoint: "/betradar/stream?radarId=".concat(radarId),
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_BETRADAR_STREAM,
                    ActionTypes.FAILURE_FETCH_BETRADAR_STREAM
                ],
                credentials: true,
            },
            _a));
    };
}
export function toggleStream() {
    return { type: ActionTypes.TOGGLE_STREAM };
}
export function resetBetradar() {
    return { type: ActionTypes.RESET_BETRADAR };
}



// WEBPACK FOOTER //
// ./src/actions/creators/betradar.js